import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animationVariants';

const Footer = () => {
    return (
        <motion.footer
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            className="w-full border-t border-white/10 bg-charcoal-dark pt-10 pb-8 mt-auto"
        >
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 px-6 max-w-7xl mx-auto">
                <div className="flex flex-col items-center md:items-start gap-2">
                    <span className="text-white text-lg font-bold tracking-tighter">
                        Seif <span className="text-gradient-gold">Elshemy</span>
                    </span>
                    <p className="text-sm font-medium text-text-secondary-dark">
                        Frontend Developer | React.js & TypeScript
                    </p>
                </div>
                
                <div className="flex flex-col items-center md:items-end gap-2">
                    <div className="flex items-center gap-6">
                        <a className="text-text-secondary-dark hover:text-gold transition-colors font-medium text-sm" href="https://github.com/seifelshemy21" target="_blank" rel="noreferrer">
                            GitHub
                        </a>
                        <a className="text-text-secondary-dark hover:text-gold transition-colors font-medium text-sm" href="https://www.linkedin.com/in/seif-elshemy" target="_blank" rel="noreferrer">
                            LinkedIn
                        </a>
                        <a className="text-text-secondary-dark hover:text-gold transition-colors font-medium text-sm" href="mailto:seifelshemy1@gmail.com">
                            Email
                        </a>
                    </div>
                    <p className="text-xs text-text-secondary-dark/60 font-medium">
                        © {new Date().getFullYear()} Seif Elshemy. All rights reserved.
                    </p>
                </div>
            </div>
        </motion.footer>
    );
};

export default Footer;